export const inputIds = {
    confirmPasswordResetEmail: 'confirmPasswordResetEmail',
    confirmPasswordResetPassword: 'confirmPasswordResetPassword',
    confirmPasswordResetVerificationCode:
        'confirmPasswordResetVerificationCode',
};
